import { render } from "./ContactsView.vue?vue&type=template&id=51c891b7&scoped=true&ts=true&lang=pug"
import script from "./ContactsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactsView.vue?vue&type=script&lang=ts&setup=true"

import "./ContactsView.vue?vue&type=style&index=0&id=51c891b7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c891b7"]])

export default __exports__